import { LocationGroupsSchema } from "@/modules/admin/objects/facility";
import { GuestDetailSchema } from "../guest/GuestDetail";
import { StaffUserSchema } from "../guest/StaffUser";
import { QcUserSchema } from "./QcUser";
import { z } from "zod";
import { QcBizLocationGroupOnlySchema } from "../group/QcBizLocationGroupOnly";
import { QcBizMainMenuForQcBizInquirySchema } from "./MainMenu";
import { QcBizSubMenuForQcBizInquirySchema } from "../guest/SubMenu";

export type RespondInquiryForwardResponse = z.infer<typeof RespondInquiryForwardResponseSchema>;
export const RespondInquiryForwardResponseSchema = z.object({
  default_limit: z.number().optional().nullable(),
  message: z.string().optional(),
  respond: z.boolean().optional(),
  url: z.string().optional().nullable(),
});

export type RespondHotelGuestResponse = z.infer<typeof RespondHotelGuestResponseSchema>;
export const RespondHotelGuestResponseSchema = z.object({
  message: z.string(),
  assigned: z.boolean(),
});

export type RespondInquiryResponse = z.infer<typeof RespondInquiryResponseSchema>;
export const RespondInquiryResponseSchema = z.object({
  assigned: z.boolean().optional(),
  message: z.string().optional(),
  success: z.boolean().optional(),
});

export type InquiryInfo = z.infer<typeof InquiryInfoSchema>;
export const InquiryInfoSchema = z.object({
  menu_header: z.string(),
  room_number: z.string(),
  change_location: z.string().nullable(),
  location_group: LocationGroupsSchema,
  inquiry_type: z.number(),
  conversation_state: z.string(),
  conversation_id: z.string(),
  staff_conversation_id: z.string(),
  guest: GuestDetailSchema,
  staff: StaffUserSchema.nullable(),
  is_check_out: z.boolean(),
});

export type EarliestInquiryInfo = z.infer<typeof EarliestInquiryInfoSchema>;
export const EarliestInquiryInfoSchema = z.object({
  inquiry_id: z.number(),
  info: InquiryInfoSchema,
  session_id: z.string().nullable(),
  is_busy: z.boolean(),
});

export type ListAssignedInquiriesResponse = z.infer<typeof ListAssignedInquiriesResponseSchema>;
export const ListAssignedInquiriesResponseSchema = z.object({
  has_working_inquiries: z.boolean().optional(),
});

export type QcBizInquiryForConvInfo = z.infer<typeof QcBizInquiryForConvInfoSchema>;
export const QcBizInquiryForConvInfoSchema = z.object({
  change_location: z.string().nullable(),
  guest_id_account: z.number().nullable(),
  id: z.number().nullable(),
  inquiry_type: z.number().nullable(),
  is_check_out: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  live_chat_strategy: z.string().nullable(),
  location_group: QcBizLocationGroupOnlySchema.optional(),
  main_menu: QcBizMainMenuForQcBizInquirySchema.nullable(),
  main_menu_id: z.number().nullable(),
  staff_group_ids: z
    .array(z.number())
    .nullable()
    .transform((value) => value ?? []),
  staff_group_names: z
    .array(z.string())
    .nullable()
    .transform((value) => value ?? []),
  staff_qc_user_by_ticket_queue: QcUserSchema.nullable(),
  sub_menu: QcBizSubMenuForQcBizInquirySchema.nullable(),
  sub_menu_id: z.number().nullable(),
});
